export { default } from "./CompareMobile";
export * from "./CompareMobile";
